<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div
        class="titleTextFont font-weight-normal text-center"
        style="font-size: 2.4rem"
        [ngStyle]="{ color: titlesColor }"
      >
        {{ title }}
      </div>
    </div>
    <div class="col-12">
      <div
        class="font-weight-normal fadeIn text-center mb-3 subtitle-block"
        style="font-size: 1.5rem"
      >{{ subtitle }}</div>
    </div>
  </div>

  <div class="carousel row slide block-sliders__carousel" data-ride="carousel">
    <div class="carousel-inner">
      <div
        *ngFor="let item of slider; let i = index"
        class="carousel-item col-12 col-md-4"
        [class.active]="i === 0"
      >
        <a [href]="item.url">
          <img
            sizes="100vw"
            class="d-block w-100"
            alt=""
            loading="lazy"
            decoding="async"
            [src]="item.image"
          />
          <div
            class="carousel-caption d-md-block"
            style="padding: 2rem"
            *ngIf="item.title || item.description"
          >
            <div class="text-secondary" *ngIf="item.title">{{ item.title }}</div>
            <div
              class="text-secondary"
              style="font-size: 1.3rem"
              *ngIf="item.description"
            >{{ item.description }}</div>
            <div class="overlay-slider-custom"></div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
